module.exports = __webpack_public_path__ + "img/cattunnel44.a72834d4.jpg";